import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1789306d&scoped=true&"
var script = {}
import style0 from "@/assets/css/common.css?vue&type=style&index=0&id=1789306d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1789306d",
  null
  
)

export default component.exports